
export default {
  name: 'AdminRibbon',
  props: {
    activeMenu: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => {}
    },
    text: {
      type: Object,
      default: () => {}
    }
  }
}
